module.exports = __webpack_public_path__ + "efc018cc914fe9902bf50abeecb8f22a.png";